import { Component, DestroyRef, effect, inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
    MatTableDataSource,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
} from '@angular/material/table';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Function } from 'src/app/models/centrex/function';
import { FunctionService } from 'src/app/services/centrex/function.service';
import { DialogDeleteConfirmationComponent } from '../../dialogs/dialog-delete-confirmation/dialog-delete-confirmation.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButton, MatIconButton } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { InstanceService } from 'src/app/services/centrex/instance.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-functions',
    templateUrl: './functions.component.html',
    styleUrls: ['./functions.component.scss'],
    imports: [
        FaIconComponent,
        ReactiveFormsModule,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        TranslateModule,
    ],
})
export class FunctionsComponent {
    private readonly instanceService = inject(InstanceService);
    private destroyRef = inject(DestroyRef);

    // Icône
    public faAngleRight = faAngleRight;

    displayedColumns: string[] = ['number', 'name', 'type'];
    dataSource: MatTableDataSource<Function>;
    deleteConfirmationDialog: MatDialogRef<DialogDeleteConfirmationComponent>;

    filtersForm: UntypedFormGroup;

    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    constructor(
        private functionService: FunctionService,
        private dialog: MatDialog,
        private translate: TranslateService,
        private toastr: ToastrService,
        private formbuilder: UntypedFormBuilder,
        private spinner: NgxSpinnerService
    ) {
        this.filtersForm = new UntypedFormGroup({});
        //this.initFiltersForm();

        effect(() => {
            if (this.instanceService.instance()) {
                this.loadDatas();
                //this.initFiltersForm();
            }
        });
    }

    // /**
    //  * Initialisation du formulaire des filtres du tableau des functions
    //  */
    // initFiltersForm() {
    //     this.filtersForm = this.formbuilder.group({
    //         id: [''],
    //number: [''],
    //name: [''],
    //type: [''],
    //     });
    // }

    loadDatas() {
        this.spinner.show();
        this.functionService
            .getFunctions()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (functions) => {
                    this.dataSource = new MatTableDataSource(functions);

                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;

                    //this.createFilters();

                    this.spinner.hide();
                },
                error: () => {
                    this.spinner.hide();
                },
            });
    }

    //  createFilters() {
    //this.dataSource.filterPredicate = (data: Function, filter: string) => {
    //          const filterArray = filter.split('¤');
    //          const matchFilter = [];

    //          matchFilter.push(data.id && data.id.trim().toLowerCase().includes(filterArray[0].trim().toLowerCase()));
    //	matchFilter.push(data.number && data.number.trim().toLowerCase().includes(filterArray[1].trim().toLowerCase()));
    //          matchFilter.push(data.name && data.name.trim().toLowerCase().includes(filterArray[1].trim().toLowerCase()));
    //	matchFilter.push(data.type && data.type.trim().toLowerCase().includes(filterArray[1].trim().toLowerCase()));

    //          return matchFilter.every(Boolean);
    //      };

    //this.displayedColumns = ['number', 'name', 'type'];

    //      this.applyFilters();
    //  }

    //  /**
    //   * Application du filtre dans le tableau des functions
    //   */
    //  applyFilters() {
    //      const id = this.filtersForm.get('id').value;
    //const number = this.filtersForm.get('number').value;
    //      const name = this.filtersForm.get('name').value;
    //const type = this.filtersForm.get('type').value;

    //const filterValue = (!!id ? id : '') + '¤' + (!!number ? number : '') + '¤' + (!!name ? name : '') + '¤' + (!!type ? type : '');

    //      this.dataSource.filter = filterValue.trim().toLowerCase();

    //      if (this.dataSource.paginator) {
    //          this.dataSource.paginator.firstPage();
    //      }
    //  }

    //  /**
    //   * Réinitialise le filtre de la colonne spécifiée.
    //   * @param formControlName Nom du contrôle du formulaire
    //   */
    //  resetColumnFilter(formControlName: string): void {
    //      this.filtersForm.controls[formControlName].reset();
    //      this.applyFilters();
    //  }

    //  /**
    //   * Réinitialise tous les filtres de colonne
    //   */
    //  resetAllColumnFilter() {
    //      this.filtersForm.reset();
    //      this.applyFilters();
    //  }
}
